var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showAdd = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            strip: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumn, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  formatter: item.formatter,
                  prop: item.prop
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.editItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showAdd,
            width: "500px",
            title: _vm.regionForm.id ? "编辑" : "新增",
            closeable: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showAdd = $event
            },
            open: _vm.onAddDialogOpen,
            close: _vm.onAddDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "regionForm",
              attrs: {
                rules: _vm.regionRule,
                "label-width": "120",
                model: _vm.regionForm
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "服务区域",
                    prop: "regionalName",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写服务区域" },
                    model: {
                      value: _vm.regionForm.regionalName,
                      callback: function($$v) {
                        _vm.$set(_vm.regionForm, "regionalName", $$v)
                      },
                      expression: "regionForm.regionalName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "接口域名",
                    prop: "regionalDomainName",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写接口域名" },
                    model: {
                      value: _vm.regionForm.regionalDomainName,
                      callback: function($$v) {
                        _vm.$set(_vm.regionForm, "regionalDomainName", $$v)
                      },
                      expression: "regionForm.regionalDomainName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "MQTT域名",
                    prop: "mqttDomainName",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写MQTT域名" },
                    model: {
                      value: _vm.regionForm.mqttDomainName,
                      callback: function($$v) {
                        _vm.$set(_vm.regionForm, "mqttDomainName", $$v)
                      },
                      expression: "regionForm.mqttDomainName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "TCP域名",
                    prop: "tcpDomainName",
                    required: ""
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写TCP域名" },
                    model: {
                      value: _vm.regionForm.tcpDomainName,
                      callback: function($$v) {
                        _vm.$set(_vm.regionForm, "tcpDomainName", $$v)
                      },
                      expression: "regionForm.tcpDomainName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      placeholder: "请填写",
                      maxlength: "200",
                      type: "textarea",
                      rows: "5"
                    },
                    model: {
                      value: _vm.regionForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.regionForm, "remark", $$v)
                      },
                      expression: "regionForm.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSaveRegion }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }